import { render, staticRenderFns } from "./PageOne.vue?vue&type=template&id=72036b06&scoped=true&"
import script from "./PageOne.vue?vue&type=script&lang=js&"
export * from "./PageOne.vue?vue&type=script&lang=js&"
import style0 from "./PageOne.vue?vue&type=style&index=0&id=72036b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72036b06",
  null
  
)

export default component.exports